var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ImportIntoConfigureGalleryDto, ImportIntoUserGalleryDto, ImportUserGraphIntoConfigureGalleryDto } from '../../../../../shared/service-proxies/service-proxies';
import { GraphicsType } from '../../../shared/helpers/graphics-type-help';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var RenameGraphSettingModalComponent = /** @class */ (function (_super) {
    __extends(RenameGraphSettingModalComponent, _super);
    function RenameGraphSettingModalComponent(injector, systemGalleryService, userGalleryAppSerivceService, galleryService, bsModalRef, elRef) {
        var _this = _super.call(this, injector) || this;
        _this.systemGalleryService = systemGalleryService;
        _this.userGalleryAppSerivceService = userGalleryAppSerivceService;
        _this.galleryService = galleryService;
        _this.bsModalRef = bsModalRef;
        _this.elRef = elRef;
        _this.saving = false;
        _this.namerequired = true;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(RenameGraphSettingModalComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    RenameGraphSettingModalComponent.prototype.ngOnInit = function () {
        this.renameGraphSetting = this.graphState;
        this.renameGraphName = this.graphState.name;
        $(this.elRef.nativeElement).parent('.modal-content').draggable({
            cursor: 'pointer',
            handle: '.modal-header'
        });
    };
    RenameGraphSettingModalComponent.prototype.save = function () {
        this.saving = true;
        // eslint-disable-next-line eqeqeq
        if (this.renameGraphSetting.graphicsType == GraphicsType.system) {
            this.sysNameSave();
            // eslint-disable-next-line eqeqeq
        }
        else if (this.renameGraphSetting.graphicsType == GraphicsType.current) {
            this.currentNameSave();
        }
        else {
            this.userNameSave();
        }
    };
    RenameGraphSettingModalComponent.prototype.sysNameSave = function () {
        var _this = this;
        var input = new ImportIntoConfigureGalleryDto();
        input.configureId = this.configureId;
        input.categoryId = this.renameGraphSetting.categoryId;
        input.graphId = this.renameGraphSetting.graphId;
        input.name = this.renameGraphName;
        this.systemGalleryService.importIntoConfigureGallery(input)
            .pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function (r) {
            if (r === 0) {
                _this.close({ newName: _this.renameGraphName });
                _this.notify.info(_this.l('SavedSuccessfully'));
            }
            else {
                _this.namerequired = false;
            }
        });
    };
    RenameGraphSettingModalComponent.prototype.userNameSave = function () {
        var _this = this;
        var userInput = new ImportUserGraphIntoConfigureGalleryDto();
        userInput.userGalleryId = this.renameGraphSetting.userGalleryId;
        userInput.configureId = this.configureId;
        userInput.userGraphId = this.renameGraphSetting.graphId;
        userInput.userGraphName = this.renameGraphName;
        this.userGalleryAppSerivceService.importUserGraphIntoConfigureGallery(userInput)
            .pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function (r) {
            if (r === 0) {
                _this.close({ newName: _this.renameGraphName });
                _this.notify.info(_this.l('SavedSuccessfully'));
            }
            else {
                _this.namerequired = false;
            }
        });
    };
    RenameGraphSettingModalComponent.prototype.currentNameSave = function () {
        var _this = this;
        var currentInput = new ImportIntoUserGalleryDto();
        currentInput.userId = this.renameGraphSetting.userId;
        currentInput.configureId = this.configureId;
        currentInput.configureGraphId = this.renameGraphSetting.graphId;
        currentInput.graphName = this.renameGraphName;
        this.galleryService.importConfigureGraphIntoUserGallery(currentInput)
            .pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function (r) {
            if (r === 0) {
                _this.close({ newName: _this.renameGraphName });
                _this.notify.info(_this.lc('ImportSuccessfully'));
            }
            else {
                _this.namerequired = false;
            }
        });
    };
    RenameGraphSettingModalComponent.prototype.valueChange = function () {
        this.namerequired = true;
    };
    RenameGraphSettingModalComponent.prototype.close = function (modalResult) {
        this.bsModalRef.hide();
        this._onClosed.next(modalResult);
        this._onClosed.complete();
    };
    RenameGraphSettingModalComponent = __decorate([
        Component({
            selector: 'rename-graph-setting-modal',
            template: "<form #renameGraphSettingModalForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header\"> <h4 class=\"modal-title\"> {{lc(\"Rename\")}} </h4> <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"close()\"> <span aria-hidden=\"true\">&times;</span> </button> </div> <div class=\"modal-body\"> <div class=\"modal-body-content\"> <div class=\"form-group\"> <label> {{lc(\"RenameGraphics\")}} </label> <input autoFocus type=\"text\" name=\"GraphName\" class=\"form-control fc-Form\" [(ngModel)]=\"renameGraphName\" #GraphName=\"ngModel\" (ngModelChange)=\"valueChange()\" required pattern=\"^[\u4e00-\u9fa5a-zA-Z0-9\_\-]+$\" [maxLength]=\"20\" /> </div> <div class=\"row\"> <div class=\"col-xs-12\"> <div [hidden]=\"renameGraphSettingModalForm.form.valid || renameGraphSettingModalForm.form.pristine\"> <ul class=\"help-block text-danger\" *ngIf=\"GraphName.errors\"> <li [hidden]=\"!GraphName.errors.required\">{{lc(\"NameRequired\")}}</li> <li [hidden]=\"!GraphName.errors.pattern\">{{lc(\"NameHasSpecialCharacters\")}}</li> </ul> </div> <div [hidden]=\"namerequired\"> <ul class=\"help-block text-danger\"> <li>{{lc(\"GraphNameExist\")}}</li> </ul> </div> </div> </div> </div> </div> <div class=\"modal-footer\"> <button [disabled]=\"saving\" type=\"button\" class=\"btn fc-btn btn-cancel\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> <button type=\"submit\" class=\"btn fc-btn btn-save\" [disabled]=\"!renameGraphSettingModalForm.form.valid||saving\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> <i class=\"fa fa-save\"></i> <span>{{l(\"Save\")}}</span> </button> </div> </form> "
        })
    ], RenameGraphSettingModalComponent);
    return RenameGraphSettingModalComponent;
}(ConfigureComponentBase));
export { RenameGraphSettingModalComponent };
